import {
  Component,
  computed,
  HostListener,
  input,
  output,
} from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';

@Component({
  selector: 'lepi-day',
  imports: [],
  standalone: true,
  templateUrl: './day.component.html',
  styleUrls: ['../pick-calendar.component.css'],
})
export class Day {
  @HostListener('click') click() {
    this.daySelect.emit(this.day());
  }

  rangeState = computed(() => {
    if (this.isStart()) return 'start';
    if (this.isEnd()) return 'end';
    if (this.isInRange()) return 'between';
    return 'none';
  });

  backgroundColor = computed<string>(() => {
    if (this.isToday()) return 'today';
    if (this.isStart() || this.isEnd()) return 'selected';
    if (this.isInRange()) return 'in-range';
    return 'default';
  });

  textColor = computed<string>(() => {
    if (dayjs(this.viewDate()).get('month') !== this.day().get('month')) {
      return 'prev-month';
    }

    if (this.isStart() || this.isEnd() || this.isToday()) {
      return 'today';
    }

    if (this.day().get('day') === 0) {
      return 'sunday';
    }

    if (this.day().get('day') === 6) {
      return 'saturday';
    }

    return 'default';
  });

  daySelect = output<Dayjs>();

  viewDate = input.required<Date>(); // 현재 달력의 기준월 확인용
  day = input.required<Dayjs>();

  isStart = input<boolean>(false);
  isEnd = input<boolean>(false);
  isInRange = input<boolean>(false);

  isToday = computed<boolean>(
    () => dayjs().format('YYYY-MM-DD') === this.day().format('YYYY-MM-DD')
  );
}
